import {defineMessages} from 'react-intl';

export default defineMessages({
  noItems: {
    defaultMessage: 'Sorry, no items available.',
    id: 'DataTable.NoItems',
  },
});
